<template>
  <div>
      <h1 class="mt-2 mb-4">Гематологический атлас</h1>
      
      <div class="mb-4" style="display: flex; align-items: center;">
          <span>Сетка</span>
          <p-toggle-switch v-model="isGridView" class="ml-2" />
      </div>

      <div v-if="loading" class="loading-spinner">
          <ProgressSpinner />
      </div>
      <div v-else-if="error" class="error-message">
          {{ error }}
      </div>
      <div v-else>
          <AtlasGridView 
              v-if="!isGridView"
              :categories="categories"
          />
          <AtlasTreeView
              v-else
              :categories="categories"
          />
      </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import http from "@/http";
import ProgressSpinner from 'primevue/progressspinner';
import AtlasGridView from '@/components/atlas/AtlasGridView.vue';
import AtlasTreeView from '@/components/atlas/AtlasTreeView.vue';
import pToggleSwitch from 'primevue/togglebutton';

const categories = ref([]);
const loading = ref(true);
const error = ref(null);
const isGridView = ref(false);

onMounted(async () => {
  try {
      const response = await http.get('/atlas/categories/tree');
      categories.value = response.data;
  } catch (err) {
      error.value = 'Ошибка при загрузке категорий';
      console.error('Error fetching categories:', err);
  } finally {
      loading.value = false;
  }
});
</script>

<style scoped>
.loading-spinner {
  text-align: center;
  padding: 2rem;
}

.error-message {
  color: var(--error, #f44336);
  text-align: center;
  padding: 1rem;
  background: #fee;
  border-radius: 4px;
  margin-top: 1rem;
}
</style>